module.exports = __webpack_public_path__ + "static/frontier_short.77699608.png";